import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { GlobalNotificationsState } from './types';

export const defaultGlobalNotificationsState: GlobalNotificationsState = {
  globalNotifications: []
};

export default function reducer(state: GlobalNotificationsState = defaultGlobalNotificationsState, action: Actions): GlobalNotificationsState {
  switch (action.type) {
    case ActionTypes.SPAWN_GLOBAL_NOTIFICATION:
      return { ...state, globalNotifications: [...state.globalNotifications, action.payload] };
    case ActionTypes.DISMISS_GLOBAL_NOTIFICATION:
      return { ...state, globalNotifications: state.globalNotifications.filter((n) => n.id !== action.payload.id) };
    default:
      return state;
  }
}
